<template>
  <div>
    <table width="100%" class="TB_COLLAPSE">
      <thead>
        <tr>
          <th>选项</th>
          <th colspan="3">内容</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th class="tc" width="10%">其他</th>
          <td class="tl">
            <div class="left ml-2">
              香港六合彩 开关盘时间:默认开盘时间
              <InputNumber
                :max="24"
                :min="0"
                v-model="time1.hour"
                class="ml-1 mr-1"
                style="width:50px"
              ></InputNumber>时
              <InputNumber
                :max="60"
                :min="0"
                v-model="time1.minute"
                class="ml-1 mr-1"
                style="width:50px"
              ></InputNumber>分，默认非特码停押时间
              <InputNumber
                :max="24"
                :min="0"
                v-model="time2.hour"
                class="ml-1 mr-1"
                style="width:50px"
              ></InputNumber>时
              <InputNumber
                :max="60"
                :min="0"
                v-model="time2.minute"
                class="ml-1 mr-1"
                style="width:50px"
              ></InputNumber>分，默认关盘时间
              <InputNumber
                :max="24"
                :min="0"
                v-model="time3.hour"
                class="ml-1 mr-1"
                style="width:50px"
              ></InputNumber>时
              <InputNumber
                :max="60"
                :min="0"
                v-model="time3.minute"
                class="ml-1 mr-1"
                style="width:50px"
              ></InputNumber>分
            </div>
          </td>
        </tr>
        <tr>
          <th>公司名称</th>
          <td>
            <Input v-model="company" style="width:200px;" class="left ml-2" />
          </td>
        </tr>
      </tbody>
    </table>
    <Row type="flex" align="middle" justify="center" class="mt-4 mb-2">
      <Button type="error" size="large" @click="modify">储存</Button>
    </Row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: 'miscellaneous',
  data () {
    return {
      mislt_data: [],
      time1: {
        hour: 0,
        minute: 0
      },
      time2: {
        hour: 0,
        minute: 0
      },
      time3: {
        hour: 0,
        minute: 0
      },
      company: ""
    };
  },
  computed: {
    ...mapGetters(['getmember'])
  },
  created () {
    this.mislt();
  },
  methods: {
    async mislt () {
      try {
        const res = await this.$axios.setting.getMiscellaneous()
        if ('status' in res && res.status === 0) return
        this.mislt_data = res;
        this.time1.hour = parseInt(res[0].misve1.split(":")[0]),
          this.time1.minute = parseInt(res[0].misve1.split(":")[1]),
          this.time2.hour = parseInt(res[0].misve2.split(":")[0]),
          this.time2.minute = parseInt(res[0].misve2.split(":")[1]),
          this.time3.hour = parseInt(res[0].misve3.split(":")[0]),
          this.time3.minute = parseInt(res[0].misve3.split(":")[1]),
          this.company = res[0].misve5
      } catch (error) {
        console.error(error)
      }
    },
    async modify () {
      try {
        const obj = {
          loid: this.getmember.pid,
          misve: [
            { misid: "1", misve: `${this.time1.hour}:${this.time1.minute}:00` },
            { misid: "2", misve: `${this.time2.hour}:${this.time2.minute}:00` },
            { misid: "3", misve: `${this.time3.hour}:${this.time3.minute}:00` },
            { misid: "5", misve: this.company }
          ]
        }
        const res = await this.$axios.setting.modifyMiscellaneous(obj)
        if (res.status != 1) this.$Message.error('修改失败')
        this.$Message.success("已修改");
        this.mislt();
      } catch (error) {
        console.error(error);
        this.$Message.error("資料异常");
      }
    }
  }
};
</script>
